module.exports = __webpack_public_path__ + "static/media/2023-PriorFundingInformation.7aa24048.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023-PriorFundingInformation.pdf
// module id = 132
// module chunks = 0